import { LucideIcon } from 'lucide-react';

export default function StatCard({
  icon: Icon,
  label,
  value,
  hint,
  tone = 'brand',
  onClick,
}: {
  icon: LucideIcon;
  label: string;
  value: number | string;
  hint?: string;
  tone?: 'brand' | 'amber' | 'orange' | 'purple' | 'emerald' | 'slate';
  onClick?: () => void;
}) {
  const tones: Record<string, { bg: string; iconBg: string; iconColor: string }> = {
    brand: { bg: 'bg-brand-50', iconBg: 'bg-brand-100', iconColor: 'text-brand-700' },
    amber: { bg: 'bg-amber-50', iconBg: 'bg-amber-100', iconColor: 'text-amber-700' },
    orange: { bg: 'bg-orange-50', iconBg: 'bg-orange-100', iconColor: 'text-orange-700' },
    purple: { bg: 'bg-purple-50', iconBg: 'bg-purple-100', iconColor: 'text-purple-700' },
    emerald: { bg: 'bg-emerald-50', iconBg: 'bg-emerald-100', iconColor: 'text-emerald-700' },
    slate: { bg: 'bg-slate-50', iconBg: 'bg-slate-100', iconColor: 'text-slate-700' },
  };
  const t = tones[tone];
  return (
    <button
      onClick={onClick}
      disabled={!onClick}
      className={`card p-4 sm:p-5 text-left transition ${onClick ? 'hover:shadow-pop hover:-translate-y-0.5 cursor-pointer' : 'cursor-default'}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 sm:w-11 sm:h-11 rounded-xl ${t.iconBg} grid place-items-center`}>
          <Icon className={`h-5 w-5 ${t.iconColor}`} />
        </div>
      </div>
      <div className="text-2xl sm:text-3xl font-bold text-slate-900 leading-none">{value}</div>
      <div className="text-sm font-semibold text-slate-700 mt-1.5">{label}</div>
      {hint && <div className="text-xs text-slate-500 mt-0.5">{hint}</div>}
    </button>
  );
}
